import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./Button.css";
import LoaderComponent from "../loader/Loader.jsx";
import { useNavigate } from "react-router-dom";

// Icons
import { HiArrowLeft, HiArrowRight } from "react-icons/hi";
import { TbCheck } from "react-icons/tb";

function Button({
  text,
  onClick,
  loading = false,
  colorLoading = "white",
  to,
  style = {},
  iconRight = false,
  iconLeft = false,
  skin = "default",
  disabled = false,
  success = false,
  children,
  className = "",
  animated = false,
  ...props
}) {
  const navigate = useNavigate();
  const navigation = (to) => {
    navigate(to);
  };

  return (
    <Fragment>
      {loading ? (
        <button
          className={`Button ${skin} loading ${className}  ${
            disabled && "disabled"
          }`} // Ajout de className ici
          onClick={onClick}
          style={style}
          disabled
          {...props}
        >
          <LoaderComponent color={colorLoading} size="sm" />
        </button>
      ) : success ? (
        <button
          className={`Button ${skin} success ${className} ${
            disabled && "disabled"
          }`} // Ajout de className ici
          onClick={onClick}
          style={style}
          disabled
          {...props}
        >
          <TbCheck className="icon" />
        </button>
      ) : (
        <button
          className={`Button ${skin} ${className}  ${disabled && "disabled"}`} // Ajout de className ici
          onClick={to ? () => navigation(to) : onClick}
          style={style}
          disabled={disabled}
          {...props}
        >
          {iconLeft === true ? <HiArrowLeft className="icon left" /> : iconLeft}
          {text || children}
          {iconRight === true ? (
            <HiArrowRight className="icon right" />
          ) : (
            iconRight
          )}
        </button>
      )}
    </Fragment>
  );
}

Button.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  to: PropTypes.string,
  style: PropTypes.object,
  iconRight: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
  iconLeft: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
  skin: PropTypes.string,
  success: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  animated: PropTypes.bool,
  colorLoading: PropTypes.string,
};

export default Button;
